import React, { useState, useEffect } from 'react';
import { AiOutlineSearch, AiOutlineLogout } from "react-icons/ai";
import { MdOutlineNotificationsNone } from "react-icons/md";
import { CgEditContrast } from "react-icons/cg";
import { getUserInfo } from "../../../service/userService";
import {
    AuthenticatedTemplate,
    UnauthenticatedTemplate, useMsal
} from "@azure/msal-react";


const SearchPanel = () => {

    const { instance } = useMsal();

    const [dropDown, setDropDown] = useState(true);
    const [darkTheme, setDarkTheme] = useState(false);

    const DropdownToggle = () => {
        setDropDown(!dropDown)
    }
    const handleLogout = () => {
        instance.logoutRedirect({
            postLogoutRedirectUri: msalConfigAuthOptions.postLogoutRedirectUri,
        });
    };
    const getUserDetails = (item) => {
        var data = getUserInfo();
        if (data.User) {
            return (data.User[item]);           
        }        
    }
    return (<>
        <div className="searchPanel">
            <div className="searchInputWrapper d-none">
                <AiOutlineSearch size="18" />
                <input type="text" className="" placeholder="Search" />
            </div>
            <MdOutlineNotificationsNone size="20" className="colorLight cursorPointer d-none" />
            <div className="userName" onClick={DropdownToggle}>
                {getUserDetails('FirstName') && getUserDetails('FirstName').slice(0, 1)}{getUserDetails('LastName') && getUserDetails('LastName').slice(0, 1)}
                <div className={`panelDropdownProfile ${dropDown ? 'd-none' : ''}`}>
                    <div className="profileDropdownItem border-bottom-light profileDropdownName">
                        👋 {getUserDetails('FirstName')} {getUserDetails('LastName')}
                    </div>
                    {/*<div className="profileDropdownItem">*/}
                    {/*    Profile Settings*/}
                    {/*</div>*/}
                    {/*<div className="profileDropdownItem">*/}
                    {/*    Notification Settings*/}
                    {/*</div>*/}
                    <div className="profileDropdownItem LogoutDropdown border-top-light" onClick={handleLogout} >
                        <AiOutlineLogout size="18" /> Logout
                    </div>
                </div>
            </div>
        </div>
    </>)
}

export default SearchPanel;